// Delivery variants leave uploaded originals and downloaded files untouched.
export function mediaPreview(value, width = 800) {
 try {
  const url = new URL(value);
  if (url.protocol !== 'https:' || url.hostname !== 'res.cloudinary.com') return value;
  const video = url.pathname.includes('/video/upload/');
  if (!video && !url.pathname.includes('/image/upload/')) return value;
  const size = Math.max(64, Math.min(1600, Math.round(width)));
  const options = video ? `so_0,f_jpg,q_auto,c_limit,w_${size}` : `f_auto,q_auto,c_limit,w_${size}`;
  url.pathname = url.pathname.replace('/upload/', `/upload/${options}/`);
  if (video) url.pathname = url.pathname.replace(/\.[a-z0-9]+$/i, '.jpg');
  return url.href;
 } catch { return value; }
}
